var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSingleEnrichment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17C18.9853 17 21 14.9853 21 12.5C21 10.0147 18.9853 8 16.5 8C14.015 8 12 10.0147 12 12.5C12 14.9853 14.0156 17 16.5 17ZM16.5 9.5C18.1544 9.5 19.5 10.8456 19.5 12.5C19.5 14.1541 18.1544 15.5 16.5 15.5C14.8459 15.5 13.5 14.1541 13.5 12.5C13.5 10.8456 14.8469 9.5 16.5 9.5ZM19.4719 18H13.5C10.7387 18 8.5 20.2384 8.5 23C8.5 23.5522 8.94781 24 9.47188 24H23.5C24.0522 24 24.4719 23.5522 24.4719 23C24.5 20.2375 22.2625 18 19.4719 18ZM10.0356 22.5C10.279 20.8059 11.74 19.5 13.5012 19.5H19.4731C21.2334 19.5 22.695 20.8059 22.9388 22.5H10.0356Z",
    fill: "#010417"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSingleEnrichment);
export default __webpack_public_path__ + "static/media/ic-single-enrichment.88a5480a8c099d28cfe07d19323cb419.svg";
export { ForwardRef as ReactComponent };